import { useMemo } from "react";
import {
  capitalizeLetter,
  defaultDateDisplay,
  formatCurrency,
  handleRenderStatusIndicator,
} from "../helpers";
import "../assets/styles/base/globalPage.scss";
import globalStyles from "../assets/styles/base/globalPage.module.scss";
import primaryComponents from "../components/primaryComponents";
import { useUpdateOrderStatusMutation } from "./api/mutations/useOrder";
import secondaryComponents from "../components/secondaryComponents";
import { orderColor } from "../helpers/constants";

const useChowdeckTableDisplay = ({
  setSelectedOrder = () => {},
  handleRefetchOrders = () => {},
}) => {
  const { updateStatus } = useUpdateOrderStatusMutation({
    onSuccess: () => {
      handleRefetchOrders();
    },
  });

  const columns = useMemo(
    () => [
      {
        Header: "Order Number",
        accessor: "id",
        Cell: ({ cell: { value }, row }) => (
          <span>
            <span
              onClick={() => {
                setSelectedOrder(value);
              }}
              style={{
                color: "#7647EE",
                cursor: "pointer",
              }}
            >
              {value}
            </span>
            <span className="d-block">
              {defaultDateDisplay(row?.original?.created_at)}
            </span>
          </span>
        ),
      },
      {
        Header: "Payment Type",
        accessor: "payment_method",
        Cell: ({ cell: { value } }) => (
          <span>{value === null ? "N/A" : value?.replace("_", " ")}</span>
        ),
      },
      {
        Header: "Customer Name",
        accessor: "customer",
        Cell: ({ cell: { value } }) =>
          value === null ? "N/A" : value?.full_name,
      },
      {
        Header: "Amount",
        accessor: "total_amount",
        Cell: ({ cell }) => (
          <span>
            {formatCurrency({
              value: cell.value,
              currencyCode: cell?.row?.original?.store?.currency_code,
            })}
          </span>
        ),
      },
      {
        Header: "Payment Status",
        accessor: "is_paid",
        Cell: ({ cell: { value } }) => (
          <span
            className={globalStyles.statusBlock}
            style={{
              ...handleRenderStatusIndicator(
                value ? "COMPLETED" : "IN_PROGRESS",
              ),
            }}
          >
            {value ? "Successful" : "Pending"}
          </span>
        ),
      },
      {
        Header: "Actions",
        accessor: "status",
        Cell: ({ cell: { value }, row }) => (
          <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <secondaryComponents.ToolTipV2 tipText="Update Order Status">
              <primaryComponents.FancySelectField
                placeholder={"Update status"}
                options={[
                  {
                    name: "Order Ready",
                    id: "ORDER_READY",
                    bgColor: "#15112d",
                  },
                ]}
                nameKey={"name"}
                idKey={"id"}
                bgKey={"bgColor"}
                colorKey={"color"}
                style={{ height: "40px" }}
                selectedItem={{
                  label: capitalizeLetter(value?.replace("_", " ")),
                  bgColor: orderColor[value]?.bgColor,
                  color: orderColor[value]?.color,
                }}
                onChange={(item) => {
                  updateStatus(row?.original?.id, item?.value);
                }}
              />
            </secondaryComponents.ToolTipV2>
          </span>
        ),
      },
    ],
    [],
  );

  return {
    columns,
  };
};

export default useChowdeckTableDisplay;
